import { ArrowsDownUpIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { type HTMLAttributes } from "react";
import { useTranslations } from "use-intl";

type SwapValuesButtonProps = HTMLAttributes<HTMLButtonElement>;

export function SwapValuesButton({
  className,
  onClick,
}: SwapValuesButtonProps) {
  const t = useTranslations();

  return (
    <button
      type="button"
      className={clsx(
        className,
        "rounded-full border border-core-rahal-800 bg-white p-1.5",
        "cursor-pointer transition-transform active:scale-90",
      )}
      onClick={onClick}
      aria-label={t("swapValues")}
    >
      <ArrowsDownUpIcon className="size-5 text-core-rahal-800" />
    </button>
  );
}
